import formatterMonetaryValue from '@/app/utils/numberUtils';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import { Box } from '@mui/material';

interface AwardsDisplayProps {
  value: string | number | null | undefined;
  variation?: boolean;
}

export default function DisplayAlert({ value, variation }: AwardsDisplayProps) {
  const formattedValue = formatterMonetaryValue(value ?? '----');

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <Box>{formattedValue}</Box>
      {variation && (
        <PriorityHighIcon
          sx={{
            fontSize: 16,
            color: '#ffc19dff',
          }}
        />
      )}
    </Box>
  );
}
